import { reactive } from 'vue';

const state = reactive({
    campaign: null,
});

const methods = {
    setCampaign: function (campaign) {
        state.campaign = campaign;
    },
}

export default {
    state: state,
    methods: methods,
};
